import { authHeaders } from '@/api';
import { apiUrl } from '@/env';
import axios from 'axios';
import { ITippspielLeaderboardEntry, ITippspielMatch, ITippspielTipp } from './types';

export const api = {
  async getMatches(token: string) {
    return axios.get<ITippspielMatch[]>(`${apiUrl}/api/v1/tippspiel/matches`, authHeaders(token));
  },
  async saveTipp(token: string, matchId: number, goalsTeam1: number, goalsTeam2: number) {
    return axios.put<ITippspielTipp>(
      `${apiUrl}/api/v1/tippspiel/matches/${matchId}/tipp`,
      { goals_team1: goalsTeam1, goals_team2: goalsTeam2 },
      authHeaders(token),
    );
  },
  async getLeaderboard(token: string) {
    return axios.get<ITippspielLeaderboardEntry[]>(`${apiUrl}/api/v1/tippspiel/leaderboard`, authHeaders(token));
  },
  async syncMatches(token: string) {
    return axios.post(`${apiUrl}/api/v1/tippspiel/sync`, {}, authHeaders(token));
  },
};
